export default __webpack_public_path__ + "images/question-icon.81417cecada1c995d8d98ee8077f1bd6.svg";